/* tslint:disable */
/* eslint-disable */
/**
 * FMS Run API
 * The FMS Run API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import type { AddressDto } from './address-dto';
// May contain unused imports in some cases
// @ts-ignore
import type { ChallengeCategoryWithChallengeDto } from './challenge-category-with-challenge-dto';
// May contain unused imports in some cases
// @ts-ignore
import type { DeliveryDto } from './delivery-dto';
// May contain unused imports in some cases
// @ts-ignore
import type { ParticipationEntitlementDto } from './participation-entitlement-dto';
// May contain unused imports in some cases
// @ts-ignore
import type { UserDto } from './user-dto';

/**
 * 
 * @export
 * @interface UpdateUserParticipationResponseDto
 */
export interface UpdateUserParticipationResponseDto {
    /**
     * Participation ID
     * @type {string}
     * @memberof UpdateUserParticipationResponseDto
     */
    'id': string;
    /**
     * Challenge category ID
     * @type {string}
     * @memberof UpdateUserParticipationResponseDto
     */
    'challengeCategoryId': string;
    /**
     * User ID
     * @type {string}
     * @memberof UpdateUserParticipationResponseDto
     */
    'userId': string;
    /**
     * Delivery address ID for finisher items (optional for digital-only challenges)
     * @type {string}
     * @memberof UpdateUserParticipationResponseDto
     */
    'deliveryAddressId'?: string;
    /**
     * Total distance covered by the user in this challenge category in meters
     * @type {number}
     * @memberof UpdateUserParticipationResponseDto
     */
    'totalDistanceCovered': number;
    /**
     * Finisher shirt size selected by the user
     * @type {string}
     * @memberof UpdateUserParticipationResponseDto
     */
    'finisherShirtSize': string;
    /**
     * Participation status
     * @type {string}
     * @memberof UpdateUserParticipationResponseDto
     */
    'status': UpdateUserParticipationResponseDtoStatusEnum;
    /**
     * Payment status
     * @type {string}
     * @memberof UpdateUserParticipationResponseDto
     */
    'paymentStatus': UpdateUserParticipationResponseDtoPaymentStatusEnum;
    /**
     * Payment amount in the local currency
     * @type {number}
     * @memberof UpdateUserParticipationResponseDto
     */
    'paymentAmount': number;
    /**
     * Price type for this participation
     * @type {string}
     * @memberof UpdateUserParticipationResponseDto
     */
    'priceType': UpdateUserParticipationResponseDtoPriceTypeEnum;
    /**
     * Electronic bib number assigned to the participant
     * @type {string}
     * @memberof UpdateUserParticipationResponseDto
     */
    'eBibNumber'?: string;
    /**
     * URL of the electronic bib number image
     * @type {string}
     * @memberof UpdateUserParticipationResponseDto
     */
    'eBibNumberImageUrl'?: string;
    /**
     * URL of the electronic certificate image
     * @type {string}
     * @memberof UpdateUserParticipationResponseDto
     */
    'eCertificateImageUrl'?: string;
    /**
     * Whether participant chose to include finisher shirt
     * @type {boolean}
     * @memberof UpdateUserParticipationResponseDto
     */
    'shouldIncludeFinisherShirt': boolean;
    /**
     * Whether participant chose to include medal
     * @type {boolean}
     * @memberof UpdateUserParticipationResponseDto
     */
    'shouldIncludeMedal': boolean;
    /**
     * Payment amount for finisher shirt when optional
     * @type {number}
     * @memberof UpdateUserParticipationResponseDto
     */
    'finisherShirtPaymentAmount': number;
    /**
     * Payment amount for medal when optional
     * @type {number}
     * @memberof UpdateUserParticipationResponseDto
     */
    'medalPaymentAmount': number;
    /**
     * Payment processing fee amount
     * @type {number}
     * @memberof UpdateUserParticipationResponseDto
     */
    'paymentProcessingFeeAmount': number;
    /**
     * Delivery fee amount
     * @type {number}
     * @memberof UpdateUserParticipationResponseDto
     */
    'deliveryFeeAmount': number;
    /**
     * Custom entitlements selected for this participation
     * @type {Array<ParticipationEntitlementDto>}
     * @memberof UpdateUserParticipationResponseDto
     */
    'participationEntitlements'?: Array<ParticipationEntitlementDto>;
    /**
     * Creation date in UTC
     * @type {string}
     * @memberof UpdateUserParticipationResponseDto
     */
    'createdAt': string;
    /**
     * Last update date in UTC
     * @type {string}
     * @memberof UpdateUserParticipationResponseDto
     */
    'updatedAt': string;
    /**
     * Challenge category details
     * @type {ChallengeCategoryWithChallengeDto}
     * @memberof UpdateUserParticipationResponseDto
     */
    'challengeCategory': ChallengeCategoryWithChallengeDto;
    /**
     * Challenge status
     * @type {string}
     * @memberof UpdateUserParticipationResponseDto
     */
    'challengeStatus': UpdateUserParticipationResponseDtoChallengeStatusEnum;
    /**
     * Progress percentage
     * @type {number}
     * @memberof UpdateUserParticipationResponseDto
     */
    'progressPercentage': number;
    /**
     * Challenge category details
     * @type {AddressDto}
     * @memberof UpdateUserParticipationResponseDto
     */
    'deliveryAddress': AddressDto;
    /**
     * Delivery details for this participation
     * @type {DeliveryDto}
     * @memberof UpdateUserParticipationResponseDto
     */
    'delivery'?: DeliveryDto;
    /**
     * User details
     * @type {UserDto}
     * @memberof UpdateUserParticipationResponseDto
     */
    'user': UserDto;
}

export const UpdateUserParticipationResponseDtoStatusEnum = {
    Ongoing: 'ongoing',
    Completed: 'completed',
    Cancelled: 'cancelled'
} as const;

export type UpdateUserParticipationResponseDtoStatusEnum = typeof UpdateUserParticipationResponseDtoStatusEnum[keyof typeof UpdateUserParticipationResponseDtoStatusEnum];
export const UpdateUserParticipationResponseDtoPaymentStatusEnum = {
    Pending: 'pending',
    Paid: 'paid',
    Failed: 'failed',
    Expired: 'expired'
} as const;

export type UpdateUserParticipationResponseDtoPaymentStatusEnum = typeof UpdateUserParticipationResponseDtoPaymentStatusEnum[keyof typeof UpdateUserParticipationResponseDtoPaymentStatusEnum];
export const UpdateUserParticipationResponseDtoPriceTypeEnum = {
    Regular: 'regular',
    EarlyBird: 'early_bird',
    Free: 'free'
} as const;

export type UpdateUserParticipationResponseDtoPriceTypeEnum = typeof UpdateUserParticipationResponseDtoPriceTypeEnum[keyof typeof UpdateUserParticipationResponseDtoPriceTypeEnum];
export const UpdateUserParticipationResponseDtoChallengeStatusEnum = {
    NotStarted: 'not_started',
    Ongoing: 'ongoing',
    Ended: 'ended',
    Cancelled: 'cancelled'
} as const;

export type UpdateUserParticipationResponseDtoChallengeStatusEnum = typeof UpdateUserParticipationResponseDtoChallengeStatusEnum[keyof typeof UpdateUserParticipationResponseDtoChallengeStatusEnum];


